/* eslint-disable */
import Vue from 'vue';
import * as Validators from "@/utils/validators";
const currencyFilter = function (value) {
    if (typeof(value) !== "number" || !Validators.isValidAmount(0, value))
        return value;
    //return "£" + value.toFixed(2);
    return  value.toFixed(2);

};

Vue.filter('currencyFilter', currencyFilter);

export default currencyFilter;
